module.exports = __webpack_public_path__ + "img/Cq2BFNQXYAU7vb_.2b0fe657.jpg";